import React from "react";
import Table from "@material-ui/core/Table";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  area: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch"
  },
  tabela: {
    [theme.breakpoints.down("xs")]: {
      "& th, & td": {
        whiteSpace: "nowrap",
        padding: "6px 8px"
      }
    }
  }
}));

const TabelaRolavel: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.area}>
      <Table className={classes.tabela}>{children}</Table>
    </div>
  );
};

export default TabelaRolavel;
